import React from "react";

export default function SQL_TOP() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_TOP</h1>
      <p>This is the SQL_TOP component generated from the SQL JSON.</p>
    </div>
  );
}
